// https://stackoverflow.com/questions/38156300/regex-how-do-you-match-korean-hangul-letters-in-javascript-es6
const re = /[\u3131-\uD79D]/giu

function splitName(name) {
	const characters = name.match(re) ? [...name] : name.split(' ')
	const join = name.match(re) ? '' : ' '
	return {
		lastName: characters[0],
		firstName: characters.slice(1).join(join)
	}
}

export default splitName
